/**
 * Toggle Module
 * data-toggle属性で指定したセレクタの要素に対して
 * is-collapsed / is-expanded をトグルする
 *
 * data-toggle-outside-close をトリガーに付けると targets外クリックで閉じる
 */

export function initToggle(): void {
	const toggleElements = document.querySelectorAll<HTMLElement>("[data-toggle]");

	for (const element of toggleElements) {
		syncAriaState(element);
		element.addEventListener("click", handleToggleClick);
	}

	document.addEventListener("click", (e) => {
		document.querySelectorAll<HTMLElement>("[data-toggle][data-toggle-outside-close]").forEach((trigger) => {
			const selector = trigger.getAttribute("data-toggle");
			if (!selector) return;
			const targets = getTargets(selector);
			if (!targets.some((t) => t.classList.contains("is-expanded"))) return;
			const clicked = e.target as Node;
			if (!trigger.contains(clicked) && targets.every((t) => !t.contains(clicked))) {
				setExpandedState(trigger, targets, false);
			}
		});
	});
}

function handleToggleClick(event: Event): void {
	event.preventDefault();

	const trigger = event.currentTarget;
	if (!(trigger instanceof HTMLElement)) {
		return;
	}

	const selector = trigger.getAttribute("data-toggle");
	if (!selector) {
		console.warn("data-toggle属性が空です");
		return;
	}

	const targets = getTargets(selector);
	if (targets.length === 0) {
		console.warn(`data-toggleの対象が見つかりません: ${selector}`);
		return;
	}

	const shouldExpand = !targets.every((target) => target.classList.contains("is-expanded"));
	setExpandedState(trigger, targets, shouldExpand);
}

function getTargets(selector: string): HTMLElement[] {
	return Array.from(document.querySelectorAll<HTMLElement>(selector));
}

function syncAriaState(trigger: HTMLElement): void {
	const selector = trigger.getAttribute("data-toggle");
	if (!selector) return;

	const targets = getTargets(selector);
	if (targets.length === 0) return;

	const isExpanded = targets.every((target) => target.classList.contains("is-expanded"));
	setAriaState(trigger, targets, isExpanded);
}

function setExpandedState(trigger: HTMLElement, targets: HTMLElement[], isExpanded: boolean): void {
	for (const target of targets) {
		target.classList.toggle("is-expanded", isExpanded);
		target.classList.toggle("is-collapsed", !isExpanded);
	}

	setAriaState(trigger, targets, isExpanded);
}

function setAriaState(trigger: HTMLElement, _targets: HTMLElement[], isExpanded: boolean): void {
	trigger.setAttribute("aria-expanded", String(isExpanded));

	const selector = trigger.getAttribute("data-toggle");
	if (selector?.startsWith("#") && !selector.includes(" ")) {
		trigger.setAttribute("aria-controls", selector.slice(1));
	}
}
